import { loadStripe } from '@stripe/stripe-js';

/**
 * Singleton Stripe.js instance, loaded with the publishable key. Client-side
 * only: it identifies the Stripe account to the Embedded Checkout iframe. The
 * session itself is minted by the gateway with the restricted key, so the key
 * here and the key behind the session must belong to the same Stripe account
 * and mode — mismatched accounts fail with the iframe simply not appearing.
 *
 * The `|| ''` shape is load-bearing on deployed builds. CDK writes `NX_` vars
 * as literal placeholders ("{{ NX_STRIPE_PUBLISHABLE_KEY }}") at `nx build`
 * time and a Lambda text-replaces them in index.html and every bundled JS file
 * afterwards. A truthy string literal survives Terser; a boolean test
 * (`process.env[...] === 'x'`, or `if (process.env[...])`) is constant-folded
 * before the Lambda runs, which deletes the placeholder and silently drops the
 * key in production while dev keeps working. A runtime <meta> read would be
 * opaque to that optimization whatever the shape, and is the better long-term
 * fix.
 *
 * Local dev uses `apps/set-edu/.env` (a dev server started before the key was
 * added must be restarted).
 */
const publishableKey = process.env['NX_STRIPE_PUBLISHABLE_KEY'] || '';

export const isStripeConfigured = publishableKey.length > 0;

// Only call loadStripe with a real key — loadStripe('') throws an
// IntegrationError that would crash the checkout page.
export const stripePromise = isStripeConfigured
  ? loadStripe(publishableKey)
  : null;
